var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isLoading
      ? _c("div", [_c("generic-loading-skeleton")], 1)
      : _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _vm.isErrored
            ? _c("div", { staticClass: "alert alert-error" }, [
                _vm._v(_vm._s(_vm.errorMsg))
              ])
            : _c("div", [
                _vm.myContent && _vm.myContent.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.myContent, function(content, i) {
                        return _c("div", { key: i }, [
                          _c(
                            "a",
                            {
                              staticClass: "d-flex pl-1",
                              attrs: {
                                href: content.url,
                                target: _vm.getLinkTarget(content)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleContentClick(content)
                                }
                              }
                            },
                            [
                              content.imageUrl
                                ? _c("img", {
                                    staticClass: "content-image",
                                    attrs: { src: content.imageUrl }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "content-title pb-16-px ml-2" },
                                [_vm._v(_vm._s(content.title))]
                              )
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  : _c("div", [_vm._v("No content to display")])
              ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pb-2" }, [
      _c("h2", [_vm._v("My content")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8edc5e04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8edc5e04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/MyContent.vue
// module id = null
// module chunks = 